import React, { useEffect } from 'react';

import defaultFavicon from '@images/favicon.png';
import notificationFavicon from '@images/favicon-notification.png';
import { NotificationSound } from './NotificationSound';

interface IHeadMeta {
  volume: number;
  notificationsCount: number;
  isNotificationsSoundEnabled: boolean;
  setTabActive: (isTabActive: boolean) => void;
  resetNotificationsCount: () => void;
}

const HeadMeta = ({
  volume,
  notificationsCount,
  isNotificationsSoundEnabled,
  setTabActive,
  resetNotificationsCount,
}: IHeadMeta) => {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    if (notificationsCount > 0) {
      link.href = notificationFavicon;
    } else {
      link.href = defaultFavicon;
    }

    const handleVisibilityChange = () => {
      setTabActive(!document.hidden);

      if (!document.hidden && notificationsCount > 0) resetNotificationsCount();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    setTabActive(!document.hidden);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [notificationsCount]);

  return (
    <>
      <NotificationSound
        volume={volume}
        isNotificationsSoundEnabled={isNotificationsSoundEnabled}
        notificationsCount={notificationsCount}
      />
    </>
  );
};

export default HeadMeta;
